import { c as _c } from "react/compiler-runtime";
import { upperFirst } from 'es-toolkit';
import { mergeClasses } from 'minimal-shared/utils';
import { labelClasses } from './classes';
import { LabelRoot, LabelIcon } from './styles';

// ----------------------------------------------------------------------

export function Label(t0) {
  const $ = _c(34);
  let children;
  let className;
  let disabled;
  let endIcon;
  let other;
  let ref;
  let startIcon;
  let sx;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      ref,
      endIcon,
      children,
      disabled,
      startIcon,
      className,
      variant: t1,
      color: t2,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = disabled;
    $[4] = endIcon;
    $[5] = other;
    $[6] = ref;
    $[7] = startIcon;
    $[8] = sx;
    $[9] = t1;
    $[10] = t2;
  } else {
    children = $[1];
    className = $[2];
    disabled = $[3];
    endIcon = $[4];
    other = $[5];
    ref = $[6];
    startIcon = $[7];
    sx = $[8];
    t1 = $[9];
    t2 = $[10];
  }
  const variant = t1 === undefined ? "soft" : t1;
  const color = t2 === undefined ? "default" : t2;
  let t3;
  if ($[11] !== className) {
    t3 = mergeClasses([labelClasses.root, className]);
    $[11] = className;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== sx) {
    t4 = Array.isArray(sx) ? sx : [sx];
    $[13] = sx;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t4) {
    t5 = [...t4];
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== startIcon) {
    t6 = startIcon && <LabelIcon className={labelClasses.icon}>{startIcon}</LabelIcon>;
    $[17] = startIcon;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== children) {
    t7 = typeof children === "string" ? upperFirst(children) : children;
    $[19] = children;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== endIcon) {
    t8 = endIcon && <LabelIcon className={labelClasses.icon}>{endIcon}</LabelIcon>;
    $[21] = endIcon;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== color || $[24] !== disabled || $[25] !== other || $[26] !== ref || $[27] !== t3 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7 || $[31] !== t8 || $[32] !== variant) {
    t9 = <LabelRoot ref={ref} color={color} variant={variant} disabled={disabled} className={t3} sx={t5} {...other}>{t6}{t7}{t8}</LabelRoot>;
    $[23] = color;
    $[24] = disabled;
    $[25] = other;
    $[26] = ref;
    $[27] = t3;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = variant;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  return t9;
}